import { RouterProvider } from "react-router/dom";

import { createBrowserRouter } from "@/router/create-browser-router";
import { appRoutes } from "@/routes/app-routes";

const router = createBrowserRouter(appRoutes);

export function App() {
  return <RouterProvider router={router} />;
}
